import { LearningPortfolioNoteUpdate } from './learning-portfolio.value';

interface UpdateTextPayloadDto {
    title: string;
    content: string;
}

interface UpdateFilePayloadDto {
    title: string;
}

export class LearningPortfolioNoteUpdateDto {
    payload: UpdateTextPayloadDto | UpdateFilePayloadDto;
    categoryIds: string[];
    attachmentIds: string[];

    constructor(value: LearningPortfolioNoteUpdate) {
        this.payload = value.type === 'text' ? { title: value.payload.title, content: value.payload.content } : { title: value.payload.title };
        this.categoryIds = value.categoryIds;
        this.attachmentIds = value.attachmentIds;
    }
}
